import React, { SyntheticEvent, useMemo } from 'react';
import { PMCConfig, CustomCtaOption } from '@kyruus/types';
import {
  Log,
  ExtendedProvider,
  FullAppointmentInfo,
  SearchSummary
} from 'Src/types';
import {
  BookOnlineListItem,
  VirtualCareListItem,
  PhoneListItem,
  RequestFormListItem,
  CustomListItem
} from './CtaListItems';
import { List } from '../styles';
import { DefaultCtaListItem, getCtaListItemsToRender } from '../lib';

interface BaseCtaListProps {
  onClose: (
    e: SyntheticEvent,
    reason?: 'backdropClick' | 'escapeKeyDown' | 'closeButton'
  ) => void;
  provider: ExtendedProvider;
  config: PMCConfig;
  searchSummary?: SearchSummary;
  apptOptions?: FullAppointmentInfo;
  log: Log;
}

type CtaListProps = BaseCtaListProps;

export const CtaList = ({
  provider,
  config,
  searchSummary,
  apptOptions = {},
  log
}: CtaListProps) => {
  const ctaListItems = useMemo(
    () => getCtaListItemsToRender({ config, provider }),
    [config, provider]
  );

  function renderListItem(listItem: DefaultCtaListItem | CustomCtaOption) {
    const isDefaultListItem = typeof listItem === 'string';
    if (!isDefaultListItem) {
      return (
        <CustomListItem
          key={(listItem as CustomCtaOption).id}
          provider={provider}
          customOption={listItem as CustomCtaOption}
          log={log}
          config={config}
        />
      );
    }
    switch (listItem) {
      case DefaultCtaListItem.BookOnline:
        return (
          <BookOnlineListItem
            key={listItem}
            provider={provider}
            config={config}
            apptOptions={apptOptions}
            searchSummary={searchSummary}
            log={log}
          />
        );
      case DefaultCtaListItem.Phone:
        return <PhoneListItem key={listItem} provider={provider} log={log} />;
      case DefaultCtaListItem.RequestForm:
        return (
          <RequestFormListItem key={listItem} provider={provider} log={log} />
        );
      case DefaultCtaListItem.VirtualCare:
        return (
          <VirtualCareListItem key={listItem} provider={provider} log={log} />
        );
      default:
        return null;
    }
  }
  return (
    <List disablePadding={true}>
      {ctaListItems.map((item) => {
        return renderListItem(item);
      })}
    </List>
  );
};
